

import { Link } from 'react-router-dom';
import { ArrowUpRight, ShieldCheck } from 'lucide-react';
function SplitFeature() {
  const stats = [
    { value: '5+', label: 'Years Of Research' },
    { value: 'ISO 9001', label: 'Certified quality system' },
    { value: '100%', label: 'In-house continuity testing' },
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28 bg-cogLight">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">

        {/* Image column */}
        <div className="lg:col-span-5 relative">
          {/* Accent borders using configuration colors */}
          <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-cogCyan/40 hidden sm:block" />

          <div className="relative overflow-hidden bg-cogBlue/5">
            <img
              src="images/about.webp"
              alt="Aerospace wiring harness assembly"
              className="w-full h-[320px] sm:h-[440px] object-cover grayscale-[15%]"
            />
            {/* Overlay updating from neutral to config ink shades */}
            <div className="absolute inset-0 bg-gradient-to-t from-cogInk/70 via-cogInk/0 to-cogInk/0" />

            <div className="absolute bottom-0 left-0 right-0 border-t border-cogLight/15 bg-cogInk/40 backdrop-blur-sm px-6 py-4 flex items-center justify-between">
              <div>
                <div className="text-cogLight font-semibold text-sm tracking-tight">
                  Built for OEM programs
                </div>
                <div className="text-cogLight/80 text-xs mt-0.5 max-w-[240px]">
                  From design and engineering through production release
                </div>
              </div>
            </div>
          </div>

          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-cogCyan/40 hidden sm:block" />
        </div>

        {/* Content column */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-2">
            <span className="text-sm font-bold text-cogCyan tracking-wider block mb-3">
              About Us
            </span>
          </div>

          <h3 className="text-2xl sm:text-3xl lg:[font-size:2.5rem] font-bold text-cogBrand mb-6 leading-[1.15] tracking-tight max-w-xl">
            Your trusted partner for wiring harness design and manufacturing
          </h3>

          <p className="text-cogBlue/70 text-base lg:text-lg leading-relaxed mb-10 max-w-xl">
            We specialize in designing and manufacturing wiring harnesses, cable
            assemblies, and interconnection systems for OEMs and industrial
            manufacturers. From engineering support and harness drawings to
            production and quality testing, we help customers build reliable
            electrical systems that are easy to assemble and built to perform.
          </p>

          {/* Stats Section matching tailwind configuration borders */}
          <div className="grid grid-cols-3 divide-x divide-cogBlue/10 border-y border-cogBlue/10 mb-10 max-w-xl">
            {stats.map((stat) => (
              <div key={stat.label} className="px-5 py-4 first:pl-0">
                <div className="text-cogBrand font-bold text-lg sm:text-xl tracking-tight">
                  {stat.value}
                </div>
                <div className="text-cogBlue/50 text-xs mt-1 leading-snug font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* Fully Rounded Button utilizing brand theme actions */}
         <Link
  to="/about"
  className="group inline-flex items-center gap-2 bg-cogBrand text-cogLight font-semibold px-8 py-3.5 rounded-full hover:bg-cogCyan transition-colors duration-300 text-sm w-fit  "
>
  <span>Learn more about us</span>
  <ArrowUpRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
</Link>
        </div>
      </div>
    </section>
  );
}

export default SplitFeature;